import { FeedItemDto, TrainingPublicationItemDto } from 'generated/CoreApi_v1';
import React from 'react';
import { TranscriptionBox } from 'views/knowledge/publication/pages/common/RightPanelContentPage/TranscriptionBox';
import { PublicationViewsBox } from 'views/lms/student/Publication/PublicationViewsBox';

export function RightPanelContentPage(publication: TrainingPublicationItemDto): React.ReactElement[] {
    return [
        <TranscriptionBox key="TranscriptionBox" publication={publication as unknown as FeedItemDto} />,
        <PublicationViewsBox key="PublicationViewsBox" publication={publication} />
    ];
}
